import { gql } from "@apollo/client";

export const ApproveAssetLocationImport = gql`
    mutation ApproveAssetLocationImport ($id: ID!, $input: AssetLocationImportUpdateAttributesInput!){
        approveAssetLocationImport(id: $id, input: $input){
            id
        }
    }
`;
